export const captureRef = (code) => {
  const clean = String(code || "").toLowerCase();
  if (/^[a-z0-9-]{2,24}$/.test(clean)) {
    localStorage.setItem("pf_ref", JSON.stringify({ code: clean, ts: Date.now() }));
  }
};

export const getRef = () => {
  try {
    const r = JSON.parse(localStorage.getItem("pf_ref"));
    if (r && Date.now() - r.ts < 30 * 86400000) return r.code;
  } catch { /* ignore */ }
  return "";
};

export const refFromUrl = () => {
  const q = new URLSearchParams(window.location.search).get("ref");
  if (q) captureRef(q);
  return getRef();
};
